import React from 'react'

import { Button, Grid, LanguageSwitcher, Space, Page, Typography } from '@probatix/common/components/atoms'
import useLocaleAwareRoute from '@probatix/common/hooks/useLocaleAwareRoute'

import { privateLandingPage, publicLandingPage } from '@probatix/myprobatix/constants/page'

import { Trans } from '@probatix/common/translations'
import useAuth from '@probatix/myprobatix/hooks/useAuth'

import { StyledLanguageSwitcher } from './NotFoundPage.styled'

interface NotFoundPageProps {
  isMobile?: boolean,
  isSmallDesktop?: boolean
}

const NotFoundView: React.FC<NotFoundPageProps> = ({ isMobile, isSmallDesktop }) => {
  const { generatePathWithLocale } = useLocaleAwareRoute()
  const { isAuthenticated } = useAuth()

  return (
    <Page>
      <StyledLanguageSwitcher>
        <LanguageSwitcher />
      </StyledLanguageSwitcher>
      <Grid>
        <Grid.Item alignItems="center" justifyContent="center">
          <Typography align="center" fontSize="32px" fontWeight={600} margin="60px 0 0">
            <Trans k="modules:special:NotFoundPage:content" />
          </Typography>
          <Typography align="center" fontSize="0.875rem" margin="20px 0 0">
            <Trans k="modules:special:NotFoundPage:content2" />
          </Typography>
          <Space space="40px" />
        </Grid.Item>
        <Grid.Item justifyContent="center">
          <Button
            fontSize={isMobile || isSmallDesktop ? '14px' : '21px'}
            fontWeight={isMobile || isSmallDesktop ? 400 : 700}
            label={(
              <Trans k="modules:special:NotFoundPage:goToHomePage" />
            )}
            mobilePadding="10px 65px"
            padding="11px 98px"
            radius="38px"
            to={isAuthenticated()
              ? generatePathWithLocale(privateLandingPage)
              : generatePathWithLocale(publicLandingPage)}
            version="yellow"
            capitalize
          />
        </Grid.Item>
      </Grid>
    </Page>
  )
}

export default NotFoundView
